import React, { useEffect, useState } from "react";
import { TextField, Select, MenuItem, Button, Box, Typography, Autocomplete, Grid } from "@mui/material";
import { ReactComponent as PlushIcon } from "../../assets/dashboardIcons/plusicon.svg"
import { ReactComponent as Wifi } from "../../assets/dashboardIcons/wifiIcon.svg"
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useForm, Controller } from "react-hook-form";
import MenuWithPDF from "../filter/MenuWithPDF";
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { resetFormSubmit } from "../../features/produzioniFormData/produzioniFormDataSlice";
import { useDispatch, useSelector } from "react-redux";
import produzioniFormAPI from "../../services/produzioniFormApi";
import { fetchProduzioineCertificazioni } from "../../features/produzioniFormData/produzioniFormDataThunk";
import { fetchStabilimenti } from "../../features/stabilimenti/stabilimentiThunk";
dayjs.locale('it');


const TableInputCertificate = ({ option, activeStep, setActiveStep }) => {
  const dispatch = useDispatch();
  const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
  const certificazioniOptons = useSelector((state) => state.produzioniForm.certificazioni) || [];
  const stabiliOptions = useSelector((state) => state.stabilimenti.stabilimenti) || [];
  const submitForm = useSelector((state) => state.produzioniForm.submitForm);

  const { control, setValue, formState: { errors } } = useForm();
  const [rows, setRows] = useState([
    {
      step: activeStep,
      company_id: Number(localStorage.getItem('company_id')),
      prod_id: singleProduzioneID,
      stabili_id: "",
      certificazione_di_origine: ""
    },
  ]);


  const onSubmit = async (formData) => {
    const data = {
      step: activeStep,
      forms: {
        certificazioni: formData
      }
    }
    console.log("Submitted data:", data);
    try {
        await produzioniFormAPI.updateStepFormData(singleProduzioneID, data);

      // setActiveStep((prev) => prev + 1);
    } catch (error) {
      fetchDataForUpdate();
      console.error('Error submitting form data:', error);
    }
  };

  const fetchDataForUpdate = async () => {
    try {
      const payload = {
        company_id: localStorage.getItem('company_id'),
        step: activeStep,
        prod_id: singleProduzioneID,
      };

      const response = await produzioniFormAPI.getSingleStepFormData(payload);
      console.log(response, "response racolta")
      if (response?.data.data.certificazioni?.length) {
        const existingTable = response.data.data.certificazioni;
        setRows(existingTable);
      }
    } catch (error) {
      console.error("Error fetching single step form data:", error);
    }
  };

  useEffect(() => {
      fetchDataForUpdate();
  }, []);


  useEffect(() => {
    if (submitForm) {
      onSubmit(rows);
      dispatch(resetFormSubmit());
    }
  }, [submitForm, dispatch]);

  useEffect(() => {
    dispatch(fetchStabilimenti());
    dispatch(fetchProduzioineCertificazioni());
  }, [dispatch])

  const handleInputChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const addRow = () => {
    setRows([
      ...rows,
      {
        step: activeStep,
        company_id: Number(localStorage.getItem('company_id')),
        prod_id: singleProduzioneID,
        stabili_id: "",
        certificazione_di_origine: ""
      },
    ]);
  };

  const handleDelete = async (index) => {
    const row = rows[index];

    if (row.id) {
      try {
        await produzioniFormAPI.deleteStepFormRow({
            id: row.id, 
            formName: "certificazioni"
        });
      } catch (err) {
        console.error("Error deleting row from server:", err);
        return;
      }
    }

    setRows((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <Box className="tableInput" sx={{ maxWidth: "100%", padding: 2 }}>
      {/* Heading */}
      <h3 className="sectiontitleSmall">Certificazione</h3>

      {/* Column Titles */}
      <Grid container spacing={1} sx={{ marginBottom: 1, fontWeight: "bold", color: "gray" }}>
        <Grid size={.5}><Typography>ID</Typography></Grid>
        <Grid size={2.5}><Typography>Certificazione di origine</Typography></Grid>
        <Grid size={2.5}><Typography>Stabilimento di stoccaggio</Typography></Grid>
      </Grid>

      {/* Dynamic Rows */}
      {rows?.map((row, index) => (
        <>

          <Grid container spacing={1} key={index} sx={{ marginBottom: 1 }}>
            <Grid size={.5}>
              <TextField
                className="customTextBox"
                label="ID"
                size="small"
                value={row?.id || index}
                disabled
              />
            </Grid>

            <Grid size={2.5}>
              <Autocomplete
                options={certificazioniOptons}
                value={row.certificazione_di_origine}
                onChange={(event, newValue) => handleInputChange(index, "certificazione_di_origine", newValue)}
                renderInput={(params) => (
                  <TextField {...params} className="customTextBox autoCompleteTextBox" label="Certificazione di origine" size="small" />
                )}
              />
            </Grid>
            <Grid size={2.5}>
              <Autocomplete
                options={stabiliOptions}
                getOptionLabel={(option) => option.nome}
                value={stabiliOptions.find((option) => option.id == row.stabili_id) || null}
                onChange={(event, newValue) => handleInputChange(index, "stabili_id", newValue.id)}
                renderInput={(params) => (
                  <TextField {...params} className="customTextBox autoCompleteTextBox" label="Stab. di destinazione" size="small" />
                )}
              />
            </Grid>

            <Grid size={.1}>
              <MenuWithPDF
                options={option}
                handleDelete={(event) => {
                  event?.stopPropagation();
                  handleDelete(index);
                }}
                id={row.id}
              />
            </Grid>


          </Grid>

        </>
      ))}

      {/* Add Button */}
      <Button
        variant="body2"
        onClick={addRow}
        sx={{
          cursor: 'pointer', color: "#225CA6", mt: 1, gap: "6px",
          fontFamily: '"Public Sans", sans-serif !important',
          '&:hover': {
            color: '#57C700',
            background: "transparent"
          }
        }}
      >
        <PlushIcon

        /> Certificazione
      </Button>

    </Box>
  );
};

export default TableInputCertificate;
